import React, { createContext } from 'react';
import KovErrorBoundary from './kovErrorBoundary';

export const KovContentBlockContext = createContext({
  baseUrl: '',
  compilerOptions: null,
  color: null,
  allTitlesH1: true,
  customComponents: undefined,
  customFuncs: undefined,
});

const KovContentBlockProvider = ({
  baseUrl,
  compilerOptions,
  color,
  customComponents,
  customFuncs,
  children,
  allTitlesH1 = true,
}) => {
  return (
    <KovContentBlockContext.Provider
      value={{ baseUrl, compilerOptions, color, customComponents, customFuncs, allTitlesH1 }}
    >
      <KovErrorBoundary>{children}</KovErrorBoundary>
    </KovContentBlockContext.Provider>
  );
};

export default KovContentBlockProvider;
